import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthUrlParts, REDIRECT_TO_PARAM } from '@examdojo/auth';
import { ToastService } from '@examdojo/core/toast';
import { AuthService, UserQuery, UserService } from '@examdojo/user';
import { filter, from, map, of, switchMap, take } from 'rxjs';

export const AuthGuard: CanActivateFn = (_, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const userService = inject(UserService);
  const userQuery = inject(UserQuery);
  const toastService = inject(ToastService);

  return authService.currentUser$.pipe(
    filter((val) => val !== null),
    take(1),
    switchMap((user) => {
      const queryParams = { [REDIRECT_TO_PARAM]: state.url };
      const loginUrlTree = router.createUrlTree([`/${AuthUrlParts.Login}`], {
        queryParams,
      });

      if (!user) {
        return of(loginUrlTree);
      }

      return userService.fetchCurrentUserRole().pipe(
        switchMap(() => userQuery.selectHasRoleOrHigher('CONTRIBUTOR').pipe(take(1))),
        switchMap((hasRole) => {
          if (!hasRole) {
            toastService.error('You do not have permission to access this page');
            return from(authService.signOut()).pipe(map(() => loginUrlTree));
          }

          return userService.fetchActiveUserProfile().pipe(map(() => true));
        }),
      );
    }),
  );
};
